import * as React from 'react';
import { useRouter } from '../contexts/router-context/router-context.js';
import { TrackingProvider } from './tracking-context.js';
import { useTracking } from './use-tracking.js';

function PageViewTracker({
  name,
  children,
  trackingData
}) {
  const {
    pathname
  } = useRouter();
  const rootTrack = useTracking();
  const properties = {
    page: name,
    ...trackingData
  };
  React.useEffect(() => {
    function track() {
      rootTrack('page_view', properties);
    }
    track();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);
  return /*#__PURE__*/React.createElement(TrackingProvider, {
    value: properties
  }, children);
}

export { PageViewTracker };
